@if (!linkToggled) {
    <span class="exclusive-icon"><vn-icon size="12" name="theme-b-exclusive" /></span>
} @else {
    <a target="_blank" [href]="sitecore.links.extendedofferhelppage?.url ?? ''">
        {{ sitecore.event.ExtendedOffer }} <vn-icon size="12" name="theme-right" />
    </a>
}
